export const ROUTES = {
    PUBLIC: {
      LOGIN: '/auth/login',
      FORGOT_PASSWORD: '/auth/forgot-password',
      RESET_PASSWORD: '/auth/reset-password',
      COMPLETE_INVITE: '/auth/complete-invite',
    },
    
    ADMIN: {
      DASHBOARD: '/admin',
      USERS: '/admin/users',
      PROFILE: '/admin/profile',
      AUDIT: '/admin/audit',
      PARTNERS: '/admin/partners',
      INTEGRATIONS: '/admin/integrations',
    },
    
    APP: {
      WIDGETS: '/widgets',
      USER_INFO: '/user-info',
      TOTP_ENROLLMENT: '/totp-enrollment',
    }
  } as const